import { HistoryTranscoderJobViewModel } from '../history/history-transcoder-job-view.model';

/** Same shape as history jobs with per-item statuses; re-exported for active tab. */
export class ActiveTranscoderJobViewModel extends HistoryTranscoderJobViewModel {}
